export const normalizePath = (value = "") =>
  String(value)
    .replaceAll("\\", "/")
    .replace(/^\.\//, "")
    .replace(/\/{2,}/g, "/")
    .replace(/^\//, "");

export const basename = (path = "") => {
  const parts = normalizePath(path).split("/");
  return parts.at(-1) || "";
};

export const dirname = (path = "") => {
  const parts = normalizePath(path).split("/");
  parts.pop();
  return parts.join("/");
};

export const joinPath = (...parts) =>
  parts
    .filter(Boolean)
    .map(normalizePath)
    .filter(Boolean)
    .join("/");

export const clamp = (value, minimum = 0, maximum = 1) =>
  Math.min(maximum, Math.max(minimum, Number(value) || 0));

export const asNumber = (value, fallback = null) => {
  const number = Number(value);
  return Number.isFinite(number) ? number : fallback;
};

export const formatScore = (value) => {
  const number = asNumber(value);
  return number === null ? "—" : number.toFixed(3);
};

export const formatDuration = (seconds) => {
  const value = asNumber(seconds);
  if (value === null) return "—";
  if (value < 60) return `${Math.round(value)}s`;
  const minutes = Math.floor(value / 60);
  const rest = Math.round(value % 60);
  return `${minutes}m ${rest}s`;
};

export const formatBytes = (bytes) => {
  const value = asNumber(bytes, 0);
  if (value < 1024) return `${value} B`;
  if (value < 1024 ** 2) return `${(value / 1024).toFixed(1)} KB`;
  return `${(value / 1024 ** 2).toFixed(1)} MB`;
};

export const escapeRegExp = (value) =>
  String(value).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

export const downloadJson = (filename, payload) => {
  const blob = new Blob([JSON.stringify(payload, null, 2)], {
    type: "application/json;charset=utf-8",
  });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = filename;
  anchor.click();
  URL.revokeObjectURL(url);
};

export const friendlyModel = (solver = "", model = "") => {
  const value = `${solver} ${model}`.toLowerCase();
  if (value.includes("opus") || value.includes("claude")) return "Opus 4.8";
  if (value.includes("gpt") || value.includes("codex")) return "GPT-5.6-sol";
  return model || solver || "Unknown model";
};

export const scoreBand = (value) => {
  const score = asNumber(value);
  if (score === null) return "missing";
  if (score >= 0.5) return "high";
  if (score >= 0.3) return "target";
  return "low";
};

export const unique = (items) => [...new Set(items)];
